<div class="contact-container">
  <div class="contact-section">
    <div class="title">
      <div class="main-title yellow-heading">Contact Us</div>
    </div>
    <div class="form-section">
      <div class="img-section">
        <img src="../../assets/images/contact-us.png" alt="" />
      </div>
      <div class="form">
        <div class="label">Let us talk!</div>
        <input type="text" [(ngModel)]="name" placeholder="type your name here..." />
        <input type="email" [(ngModel)]="mail" placeholder="type your email id here..." />
        <textarea name="" id="" cols="30" rows="10" placeholder="type your message here..."
          [(ngModel)]="description"></textarea>
        <button (click)="onClickSend()">SEND</button>
      </div>
    </div>
  </div>
  <div class="main-container">
    <div class="left-container">
      <div class="top">
        <div class="title">Get in touch</div>
        <div class="content">
          Have questions? The quickest way to get in touch with us is using the
          contact information below.
        </div>
        <div class="phone-number">
          <div class="number1">
            <img src="../../assets/images/icon 11.png" alt="" />
            <div class="text">info@thelaboratorymatters.com</div>
          </div>
          <div class="number2">
            <img src="../../assets/images/icon 12.png" alt="" />
            <div class="text">(+91) 7845647109</div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="title">How can we help?</div>
        <div class="content">
          <div class="card">
            <div class="img-section">
              <img src="../../assets/images/icon 13.png" alt="" />
            </div>
            <div class="title">Courses</div>
            <div class="content">
              Explore our wide-range of courses curated by experts, available to
              you!
            </div>
            <div class="btn">
              <button (click)="onClickBtn('courses')">Explore</button>
            </div>
          </div>
          <div class="card">
            <div class="img-section">
              <img src="../../assets/images/icon 14.png" alt="" />
            </div>
            <div class="title">Student Portal</div>
            <div class="content">
              Sign up today to start your learning journey!!
            </div>
            <div class="btn">
              <button (click)="onClickBtn('signup')">Register</button>
            </div>
          </div>
          <div class="card">
            <div class="img-section">
              <img src="../../assets/images/icon 10.png" alt="" />
            </div>
            <div class="title">Workshops</div>
            <div class="content">
              Know about our tailor made workshops & book your spot!!
            </div>
            <div class="btn">
              <button (click)="onClickWorkshop()">Enquire</button>
            </div>
          </div>
          <div class="card">
            <div class="img-section">
              <img src="../../assets/images/TEAM.png" alt="" />
            </div>
            <div class="title">Join the team</div>
            <div class="content">
              Become one of the experts and share your knowledge!!
            </div>
            <div class="btn" (click)="onClickWorkshop()">
              <button>Enquire</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="title">
        <div class="main-title">FAQ's</div>
      </div>
      <div class="faq-section">
        <div class="left">
          <div class="accordion" *ngFor="let courseQA of courseRelatedQA; let i = index">
            <div class="top">
              <div class="question">{{ courseQA.question }}</div>
              <div class="arrow" (click)="onClickArrow('course', i)">
                <i class="fa-solid fa-chevron-up" *ngIf="courseQA.active"></i>
                <i class="fa-solid fa-chevron-down" *ngIf="!courseQA.active"></i>
              </div>
            </div>
            <div class="bottom">
              <div [ngClass]="courseQA.active ? 'panel-active' : 'panel'">
                <p>
                  {{ courseQA.answer }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="accordion" *ngFor="let general of generalQA; let i = index">
            <div class="top">
              <div class="question">{{ general.question }}</div>
              <div class="arrow" (click)="onClickArrow('general', i)">
                <i class="fa-solid fa-chevron-up" *ngIf="general.active"></i>
                <i class="fa-solid fa-chevron-down" *ngIf="!general.active"></i>
              </div>
            </div>
            <div [ngClass]="general.active ? 'blue-panel-active' : 'blue-panel'">
              <p>
                {{ general.answer }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="courses-container" *ngIf="topCourses?.length">
    <div class="title">What we offer</div>
    <div class="courses">
      <div class="course" (click)="onClickCourse(course)" *ngFor="let course of topCourses; let i = index">
        <div class="thumbnail">
          <img [src]="'data:image/jpeg;base64,' + course.thumbnail.buffer" alt="" />
        </div>
        <div class="name">{{ course.title }}</div>
        <div class="description">
          {{ course.description }}
        </div>
        <div class="img-section img1" *ngIf="i == 0">
          <img src="../../assets/images/icon 03.png" alt="" />
        </div>
      </div>
    </div>
  </div> -->
</div>